import React from "react";
// components

import { PieChart, Pie, Cell, Legend, Tooltip } from "recharts";

const isTooDark = color => {
	const r = parseInt(color.slice(1, 3), 16);
	const g = parseInt(color.slice(3, 5), 16);
	const b = parseInt(color.slice(5, 7), 16);
	const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
	return luminance < 0.2;
};

export const generateRandomColor = () => {
	let color;
	do {
		color = `#${Math.floor(Math.random() * 16777215)
			.toString(16)
			.padStart(6, "0")}`;
	} while (isTooDark(color));
	return color;
};

const STATIC_COLORS = [
	"#36A2EB",
	"#FF6384",
	"#999999",
	"#4BC0C0",
	"#FFCE56",
	"#FF9F40",
	"#9966FF",
	"#FF5733",
	"#8DFF33",
	"#FF33A8",
	"#33FFF6",
];

const RADIAN = Math.PI / 180;

const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, value, total }) => {
	const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
	const x = cx + radius * Math.cos(-midAngle * RADIAN);
	const y = cy + radius * Math.sin(-midAngle * RADIAN);

	const percent = ((value / total) * 100).toFixed(1);

	if (percent === "0.0") {
		return null;
	}

	return (
		<text x={x} y={y} fill="white" textAnchor={x > cx ? "start" : "end"} dominantBaseline="central">
			{`${percent}%`}
		</text>
	);
};

export const generatePieChartsData = (table, courseKeys, provenanceKeys) => {
	return courseKeys.map(courseKey => {
		let totalValue = 0;
		const segments = provenanceKeys.map((provKey, index) => {
			const value = table.data[provKey]?.[courseKey]?.count || 0;
			totalValue += value;
			return {
				name: provKey,
				value: value,
				color: STATIC_COLORS[index % STATIC_COLORS.length],
				ids: table.data[provKey]?.[courseKey]?.ids || [],
			};
		});
		return {
			courseKey,
			totalValue,
			segments,
		};
	});
};

export const PieChartsSection = ({ table, courseKeys, provenanceKeys, name, findLeadChart }) => {
	const pieChartsData = generatePieChartsData(table, courseKeys, provenanceKeys);
	const filteredData = pieChartsData.filter(chart => chart.totalValue > 0);

	console.log("name", name);

	if (filteredData.length === 0) {
		return (
			<div
				style={{
					width: "100%",
					maxWidth: "600px",
					textAlign: "center",
					marginTop: "20px",
					padding: "20px",
					borderRadius: "8px",
				}}
			>
				<h3>{name}</h3>
				<div
					style={{
						height: "300px",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<p style={{ color: "#888" }}>Nessun dato disponibile per questa settimana</p>
				</div>
			</div>
		);
	}

	return (
		<div
			style={{
				width: "100%",
				marginBottom: "40px",
			}}
		>
			<h2 style={{ textAlign: "center" }}>{name}</h2>
			<div
				style={{
					display: "flex",
					overflowX: "auto",
					gap: "20px",
					paddingBottom: "20px",
				}}
			>
				{filteredData.map((chart, index) => (
					<div
						key={index}
						style={{
							minWidth: `300px`,
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							marginBottom: "20px",
						}}
					>
						<h4 style={{ textAlign: name === "Non buone" ? "left" : "center" }}>{chart.courseKey}</h4>

						<div style={{ position: "relative", display: "inline-block" }}>
							<PieChart width={250} height={300}>
								<Pie
									data={chart.segments}
									dataKey="value"
									nameKey="name"
									cx="50%"
									cy="40%"
									outerRadius={80}
									fill="#8884d8"
									labelLine={false}
									label={props =>
										renderCustomizedLabel({
											...props,
											total: chart.totalValue,
										})
									}
								>
									{chart.segments.map((segment, i) => (
										<Cell
											key={i}
											fill={segment.color}
											onClick={() => findLeadChart(segment.ids, chart.courseKey, segment.name)}
											style={{ cursor: "pointer" }}
										/>
									))}
								</Pie>
								<Tooltip />
								<Legend
									align="left"
									verticalAlign={name === "Non buone" ? "middle" : "bottom"}
									wrapperStyle={
										name === "Non buone"
											? { padding: "0", position: "relative", bottom: "65px" }
											: { marginTop: "5px" }
									}
									layout={"horizontal"}
								/>
							</PieChart>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};
